import ApiCaller from '../utils/apiCaller'

import BaseBOM from '@domain/catalog/BaseBOM';
import Space from '@domain/composition/Space';

type bodyType = {
    config: object
    catalogId: string,
    products: BaseBOM["props"]
    projectId?: number | null
    name?: string | null
}

class ProjectApi {
    constructor() { }

    static async addToProject(space: Space, catalog: string, BOM: BaseBOM, projectId: string | null, name: string | null = null) {
        const body: bodyType = {
            "config": space.toJSON(),
            "catalogId": catalog,
            "products": [BOM.props],
        }
        projectId != null ? body["projectId"] = parseInt(projectId) : null;
        name != null ? body["name"] = name : null;
        return await ApiCaller.call('v2', 'POST', `project`, body, { credentials: 'include' })
    }

    static async getProjects() {
        return await ApiCaller.call('projects', 'GET', `v1/projects?type=LIST&lang=es`, null, { credentials: 'include' })
    }

    static async getProjectById(id: string) {
        return await ApiCaller.call('v2', 'GET', `project/${id}`, null, { credentials: 'include' })
    }
}

export default ProjectApi